import { styled } from "@linaria/react"
import { EverGreenStyle } from "@utils/Style/everGreen"
import React, { InputHTMLAttributes } from "react"

interface IOthers extends InputHTMLAttributes<HTMLTextAreaElement> {
    charLimitlabel?:string
}

function OthersSpecify(props: React.PropsWithoutRef<IOthers>){
    const val = props.value as string 
   return (<>
    <FlexBox>
    <TextArea  {...props} />
    <div>{ val?.length || 0}/{props.charLimitlabel || 400}</div>
    </FlexBox>
    </>)
}

export default OthersSpecify

const FlexBox = styled.div`
    width: 100%;
    & div {
        text-align: end;
        color: ${EverGreenStyle.colors.grey[1500]};
        font-weight: 600;
        font-size: ${EverGreenStyle.fontSize.xs}px;
        letter-spacing: 0.18px;
    }
`

const TextArea = styled.textarea`
    box-sizing: border-box;
    resize: none;
    padding: 16px;
    border-radius: 8px;
    border: 1px ${EverGreenStyle.colors.grey[1000]} solid;
    height:142px;
    width: 100%;
    box-shadow: none;
    outline: none;
`